import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import type { TriState } from "./types";

type TriStateCheckboxProps = {
  state: TriState;
  onChange?: () => void;
  dataTestId?: string;
  ariaLabel?: string;
};

export function TriStateCheckbox({
  state,
  onChange,
  dataTestId,
  ariaLabel,
}: TriStateCheckboxProps) {
  const isDisabled = !onChange;

  return (
    <CheckboxPrimitive.Root
      aria-checked={state === "indeterminate" ? "mixed" : undefined}
      aria-label={ariaLabel}
      checked={state}
      className={cnTwMerge(
        "flex size-[18px] shrink-0 items-center justify-center rounded-[3.5px] border transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-default focus-visible:ring-offset-1",
        isDisabled && "cursor-not-allowed opacity-40",
        !isDisabled && "cursor-pointer",
        state === true &&
          "border-brand-default bg-brand-default hover:border-brand-hover hover:bg-brand-hover",
        state === "indeterminate" &&
          "border-text/tertiary bg-background/tertiary hover:border-text/secondary",
        state === false &&
          !isDisabled &&
          "border-text/secondary bg-background/primary hover:border-brand-default",
        state === false &&
          isDisabled &&
          "border-border/primary bg-background/primary",
      )}
      data-testid={dataTestId}
      disabled={isDisabled}
      onCheckedChange={onChange ? () => onChange() : undefined}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center">
        {state === true && (
          <svg fill="none" height="12" viewBox="0 0 12 12" width="12">
            <polyline
              points="2,6 5,9 10,3"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        )}
        {state === "indeterminate" && (
          <svg fill="none" height="12" viewBox="0 0 12 12" width="12">
            <line
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth="2"
              x1="3"
              x2="9"
              y1="6"
              y2="6"
            />
          </svg>
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}
